<template>
    <div class="c-o-request-form-sidebar">
        <div class="c-o-request-form-sidebar__inner">
            <queued-companies
                :showButton="true"
                class="c-m-queued-companies--shadow c-m-queued-companies--smooth-corners"
            ></queued-companies>
        </div>
    </div>
</template>

<script>
import { UPSERT_ANSWER } from "../../../store/store-models/request-form-model.js";

import Icon from "../atoms/AtomIcon.vue";
import Checkbox from "../atoms/request-form/AtomCheckboxRequestForm.vue";
import QueuedCompanies from "../molecules/MoleculeQueuedCompanies.vue";

export default {
    data() {
        return {
            heading: "Vad är detta?",
            body:
                "<p>Nedan ser du de företag du har valt till denna förfrågan. Din förfrågan kommer att skickas direkt till dessa.</p>"
        };
    },
    components: {
        Icon,
        QueuedCompanies,
        Checkbox
    },
    methods: {
        async checkboxUpdated(data) {
            await this.$store.dispatch(UPSERT_ANSWER, data);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/OrganismRequestFormSidebar.vue